// set auto cookies spaces for local dev
import { clearCookies, getCookie } from '@/helpers/cookies';
import { useAuthStore } from '@/stores/auth';
import { useGlobalStore } from '@/stores/global';

export function setSpaces() {
  const authStore = useAuthStore();
  const globalStore = useGlobalStore();
  if (getCookie('user_spaces') && getCookie('user_spaces') !== authStore?.user?.uuid) {
    clearCookieSpaces();
  }
  const role: 'admin' | 'recruiter' | 'manager' = authStore?.managers?.length ? 'manager' : 'recruiter';
  document.cookie = `role_spaces=${role};domain=${globalStore.domainCookies};path=/;`;
  if (role === 'manager') {
    document.cookie = `company_spaces=${authStore?.company_uuid};domain=${globalStore.domainCookies};path=/;`;
  }
  document.cookie = `user_spaces=${authStore?.user?.uuid};domain=${globalStore.domainCookies};path=/;`;
}

export function clearCookieSpaces() {
  const globalStore = useGlobalStore();

  const cookies = ['role_spaces', 'user_spaces'];
  const isManager = getCookie('role_spaces') === 'manager';
  if (isManager) cookies.push('company_spaces');
  clearCookies(cookies, globalStore.domainCookies);
}
